<template>
  <div class="gray-back" style="padding:.2rem 0 8rem 0" v-if="!loading">

    <div class="order-success">
      <div class="icon">
        <img v-if="formData.status == 1" src="../../../assets/images/icon-order-delivery.png" alt="">
        <img v-else src="../../../assets/images/icon-order-done.png" alt="">
      </div>

      <div class="title">{{ formData.status == 1 ? '待审核' : '审核成功' }}</div>
      <!--      <div class="desc" v-if="formData.status == 2"><p style="text-align: center">保存下方二维码可分享给指导老师或学生申报</p>-->
      <!--      </div>-->
    </div>
    <!--    <van-cell-group>-->
    <!--      <van-cell-->
    <!--          input-align="right"-->
    <!--          title="单位"-->
    <!--          :value="formData.danwei"-->
    <!--      />-->
    <!--      <van-cell-->
    <!--          input-align="right"-->
    <!--          title="联系人"-->
    <!--          :value="formData.name"-->
    <!--      />-->
    <!--      <div v-if="formData.status == 2 && formData.ewm_url">-->
    <!--        <div class="bottom-img">-->
    <!--          <img :src="formData.ewm_url" alt="">-->
    <!--        </div>-->
    <!--        <div class="bottom-img">-->
    <!--          <van-button v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存-->
    <!--          </van-button>-->
    <!--          <van-button v-else @click="onPrint" style="margin: 10px auto; text-align: center " type="default" round>-->
    <!--            点击下载图片-->
    <!--          </van-button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </van-cell-group>-->
    <van-form
        @submit="onSubmit"
        @failed="onFailed"
    >

        <van-cell-group>
          <van-field name="radio" label="类型"
                     input-align="right">
            <template #input>
              <van-radio-group v-model="formData.leixing" direction="horizontal">
                <van-radio checked-color="#ffb01b" name="2023年‘奔跑吧·少年’全国啦啦操大课间展示活动">2023年‘奔跑吧·少年’全国啦啦操大课间展示活动</van-radio>
                <!--              <van-radio checked-color="#ffb01b" name="学校俱乐部">学校俱乐部</van-radio>-->
              </van-radio-group>
            </template>
          </van-field>
          <van-field
              readonly
              clickable
              name="area"
              :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
              input-align="right"
              label="地区选择"
              placeholder="点击选择省市区"
              @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
                :area-list="areaList"
                :value="formData.area"
                @confirm="onAreaConfirm"
                @cancel="showArea = false"
            />
          </van-popup>

          <!-- <van-field
              readonly
              clickable
              :value="formData.extra_danwei.length ? formData.extra_danwei[0].name : ''"
              autosize
              type="textarea"
              input-align="right"
              label="单位名称"
              placeholder="点击选择可申报的单位"
              @click="showDanweiPicker = true"
          /> -->

                 <van-field
                     v-model="formData.danwei"
                     :rules="[{ required: true, message: '请输入准确的单位全称' }]"
                     label="单位名称"
                     input-align="right"
                     error-message-align="right"
                     clearable
                     placeholder="请输入准确的单位全称"
                />
          <van-field
              v-model="formData.address"
              :rules="[{ required: true, message: '请输入详细地址' }]"
              error-message-align="right"
              label="详细地址"
              input-align="right"
              clearable
              placeholder="请输入详细地址"
          />
          <van-field
              v-model="formData.express_name"
              :rules="[{ required: true, message: '请输入邮寄联系人及电话' }]"
              error-message-align="right"
              label="邮寄联系人及电话"
              input-align="right"
              clearable
              placeholder="请输入邮寄联系人及电话"
          />


        </van-cell-group>
      <van-divider>啦啦操推广大使</van-divider>
      <van-cell-group>
        <van-field
            v-model="formData.name"
            :rules="[{ required: true, message: '请输入姓名' }]"
            error-message-align="right"
            label="个人姓名（限1人）"
            input-align="right"
            clearable
            placeholder="请输入姓名"
        />
      </van-cell-group>
      <van-divider>联系人信息</van-divider>
      <van-cell-group>
        <van-field
            v-model="formData.contactsname"
            :rules="[{ required: true, message: '请输入联系人姓名' }]"
            error-message-align="right"
            label="联系人姓名"
            input-align="right"
            clearable
            placeholder="请输入联系人姓名"
        />
        <van-field
            v-model="formData.contactsphone"
            :rules="[{ required: true, message: '请输入联系人手机' }]"
            error-message-align="right"
            label="联系人手机"
            input-align="right"
            clearable
            placeholder="请输入联系人手机"
        />
      </van-cell-group>

      <div class="savebtn">
        <van-button
            style="width: 3rem"
            native-type="button"
            size="normal" round  @click="showTemplate = true">
          申报优秀参与人员
        </van-button>
        <!-- <van-button
            style="width: 3rem"
            native-type="button"
            
            size="normal" round  v-rblink="{'name':'DakejianApplyUploadVideo',query:{id:formData.id}}">
          视频上传
        </van-button>

        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" @click="submit">
          修改
        </van-button> -->
      </div>
    </van-form>
    <div class="cert-li" v-if="formData.cert_url && formData.cert_url.url && false">
      <van-divider>电子证书</van-divider>
      <img :src="formData.cert_url.url" alt="">
      <div class="cert-button">
        <van-button v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存
        </van-button>
        <van-button v-else @click="appDownload(formData.cert_url.filename,formData.cert_url.url)"
                    style="margin: 10px auto; text-align: center " type="default" round>点击下载
        </van-button>
      </div>
    </div>

    <van-dialog v-model="showTemplate" title="导入模板信息">
      <div class="operate-desc-left">复制下面的链接，用电脑端打开，进行批量导入操作</div>
      <!--      <div class="operate-desc-left" @click="download" style="color: #1989fa;">考级人员批量导入模版下载</div>-->
      <div class="operate-desc-left" v-clipboard:copy="formData.share"
           v-clipboard:success="onCopy"
           v-clipboard:error="onError" style="color: #666">导入模板链接地址：{{ formData.share }}
        <div class="small-button">复制</div>
      </div>
      <!--        <div class="operate-desc-left" @click="download" style="color: #1989fa;">训练营报名批量导入模版下载</div>-->
    </van-dialog>


  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.small-button {
  height: 30px;
  padding: 0 8px;
  font-size: 12px;
  line-height: 30px;
  color: #323233;
  background-color: #fff;
  border: 1px solid #ebedf0;
  display: inline-block;
}

.cert-li {
  margin: 0 .3rem;
  text-align: center;
}

.cert-li img {
  width: 100%;
  border-radius: 5px;
}

.bottom-img {
  text-align: center;
}

.bottom-img img {
  /*display: block;*/
}

.order-success {
  text-align: center;
  margin: 20px 0;
}

.order-success .icon {
  background-size: 100%;
  width: 75px;
  height: 75px;
  margin: 20px auto 20px auto;

}

.order-success .title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  text-align: center;
}

.order-success .desc {
  padding: 10px;
  text-align: left;
}

.order-success .desc p {
  line-height: 26px;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.order-success img {
  width: 90%;
  /*height: 120px;*/
  margin: 10px auto;
}

.order-success p {
  font-size: 12px;
  color: #999;
}

.sai-shuo-li {
  background: #f3f3f3;
  border-radius: 10px;
  margin: 20px 10px;
  padding: 10px;
}

.sai-shuo-li img {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  float: left;
  margin-right: 10px;
}

.sai-shuo-li .c {
  width: calc(100% - 80px);
  border-right: 1px solid #00000008;
}

.sai-shuo-li .c .title {
  font-size: 14px;
  color: #000;
}

.sai-shuo-li .c .desc {
  font-size: 12px;
  color: #999;
}

.sai-shuo-li .fr {
  width: 70px;
  float: right;
}

.sai-shuo-li .btn {
  width: 60px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  text-align: center;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 6px;
  color: #fff;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';
import VideoUploader from '@/components/picker/VideoUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import FamliyPicker from '@/components/picker/FamliyPicker.vue';


import jquery from 'jquery';

jquery.fn.longPress = function (fn) {
  let timeout = 0;
  const $this = this;
  console.log('jquery.fn.longPress')
  for (let i = 0; i < $this.length; i++) {
    $this[i].addEventListener('touchstart', () => {
      timeout = setTimeout(fn, 800); // 长按时间超过800ms，则执行传入的方法
    }, false);
    $this[i].addEventListener('touchend', () => {
      clearTimeout(timeout); // 长按时间少于800ms，不会执行传入的方法
    }, false);
  }
};

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
    VideoUploader,
  },
  data: function () {
    return {
      ltShow: false,
      loading: true,
      showArea:false,
      showTemplate: false,
      ltImgSrc: '',
      ltImgName: '',
      ltActions: [{name: '保存图片'}],
      validator,
      saveLoading: false,
      showFamliyPicker: false,
      showSubjectPicker: false,
      showJiaolianPicker: false,
      showRoomTypePicker: false,
      showMemberPicker: false,
      formData: {
        erweiimg: [],
        video: {}
      },
      isApp: window.isApp()
    }
  },
  filters: {},
  mounted() {
    document.title = "申请详情"

    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    if (that.formData.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onLtSelect(item) {
      let that = this;
      switch (item.name) {
        case '保存图片':
          let name = that.ltImgSrc.split('?')[0].split('/').pop();
          console.log(that.ltImgSrc, name);
          appEvent({
            name: 'downloadPic',
            query: {
              'filename': name,
              'url': that.ltImgSrc
            }
          });
          break;
      }
    },

    appDownload(name, url) {
      let that = this;
      console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: name + '.jpg',
          url: url,
        }
      });
    },

    onCopy(e) {
      Toast.success('复制成功');
    },
    onError(e) {
      console.log('复制失败！');
    },

    onPrint() {
      let that = this;
      // console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: that.formData.danwei + '大课间展演申报二维码',
          url: that.formData.ewm_url,
        }
      });
    },
    go(type) {
      // rbLink({name:'H5',query:{ url : this.row.jump_url } });
      let that = this;
      appEvent({
        name: 'downloadFile',
        query: {
          name: 'xxx',
          url: that.formData.jump_url,
        }
      });
    },
    onQuestion() {
      console.log('onQuestion')
    },

    onVideoInputClick() {
      let that = this;
      console.log({
        name: 'onVideoInputClick',
        query: {
          'mingcheng': this.formData.danwei,
          'subject_name': this.formData.name,
        }
      });

      appEvent({
        name: 'onVideoInputClick',
        query: {
          'mingcheng': this.formData.danwei,
          'subject_name': this.formData.name,
        }
      });
    },
    fetch() {
      let that = this;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });
      that.$api.post('/api/zdakejian/successdetail', {
        id: that.formData.id
      }, (res) => {
        that.formData = res.data;
        that.loading = false
        Toast.clear()

      }, (res) => {
        Toast.fail(res.msg);
        that.loading = false
      })
    },

    onFailed(errorInfo){
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

    onSubmit(values) {
      let that = this;
      console.log(that.formData)
      // if (this.formData.video.length == 0) {
      //   Toast('请上传视频');
      //   return;
      // }

      that.$api.post('/api/zdakejian/editDakejian', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('修改成功');
        setTimeout(function() {
          rbLink({
            name: "DakejianApplyList",
          }, 'back')
        }, 1000)
      }, (res) => {

        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        }
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// DakejianApplySuccess.vue?e22500dc